import { useState } from 'react';
import styled from 'styled-components';
import FooterModal from '../../../footer';
import { ProgressBar } from '../../../progressBar';
import { Status } from '../../../status';
import { CommitmentError } from '../../../types';
import { valuationsSteps } from '../../constants';
import { commitmentsCodesStatusError, commitmentsStatusSuccess } from './constants';
import Table from './table/table';

interface CommitmentsProps {
  importSteps: typeof valuationsSteps;
  prevStep: () => void;
  nextStep: () => void;
  tableData: any;
  commitmentError: CommitmentError[];
}

export const Commitments = ({ importSteps, prevStep, nextStep, tableData, commitmentError }: CommitmentsProps) => {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <ImportWrapper>
        <ProgressBar importSteps={importSteps} />
        <Status
          errorsCount={commitmentError.length || null}
          matched={[{ count: tableData.length, text: 'Matched' }]}
          showTable={showTable}
          setShowTable={setShowTable}
          startOver={prevStep}
          confirmButton={{ name: 'Save and Complete', onClick: nextStep, disabled: Boolean(commitmentError.length) }}
          success={commitmentsStatusSuccess}
          error={commitmentsCodesStatusError}
        />
      </ImportWrapper>
      {showTable || commitmentError?.length ? (
        <TableWrapper>
          <Table tableData={tableData} commitmentError={commitmentError} />
        </TableWrapper>
      ) : (
        <></>
      )}
      {commitmentError?.length || showTable ? (
        <FooterModal
          startOver={prevStep}
          startOverButtonName="Back"
          confirmButton={{ name: 'Save and Complete', onClick: nextStep, disabled: Boolean(commitmentError.length) }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

const ImportWrapper = styled.div`
  margin-top: 30px;
  background: #ffffff;
  padding: 40px 60px;
  border: 1px solid #c7cbd2;
  border-radius: 10px;
`;

const TableWrapper = styled.div`
  margin-bottom: 100px;
`;
